import { render } from "./LbrxKioskHeader.vue?vue&type=template&id=98737bb0&scoped=true"
import script from "./LbrxKioskHeader.vue?vue&type=script&lang=js"
export * from "./LbrxKioskHeader.vue?vue&type=script&lang=js"

import "./LbrxKioskHeader.vue?vue&type=style&index=0&id=98737bb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98737bb0"]])

export default __exports__